import { render, staticRenderFns } from "./TabsVip.vue?vue&type=template&id=c576f520&scoped=true&"
import script from "./TabsVip.vue?vue&type=script&lang=js&"
export * from "./TabsVip.vue?vue&type=script&lang=js&"
import style0 from "./TabsVip.vue?vue&type=style&index=0&id=c576f520&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c576f520",
  null
  
)

export default component.exports